import {useAppSelector} from "@Hooks/selector/useAppSelector";

export default function useIsFerry() {
    const {companyMainTransportType} = useAppSelector((state) => state?.page)

    return companyMainTransportType === 'ferry'
}